/**
 * 業者の検索ダイアログ
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/trader_members`

const getDefaultState = () => {
  return {
  }
}
const trader_member = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property search_type { string } 検索種別 transport: 収運, trader: 処分
     * @property subscriber_no { string } 加入者番号
     * @property query { string } 名称
     * @property billing_address_name { string } 請求先名
     * @property { boolean } exclude_me 自社 収運を除く
     * @property page { number } ページ番号
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 収運・処分業者の詳細情報取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}`).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    }
  },
}
export default trader_member
